import React, { useState } from 'react';

import { Stack, Typography, List, ListItemButton, ListItemText, Divider } from '@mui/material';
import ManageAssetsView, { assetViewModel } from 'src/sections/assets/manage-assets-view';
import { useFinanceContext } from 'src/components/plaid/datasource';
import { currencyFormatter } from 'src/utils/currency-formatter';
import { SlideIn } from '../SlideIn';
import { FormFooter } from './FormFooter';
// import HomesAndAssetsManager from '../homes-and-assets-manager';

export default function FinancesContent({ formData: _data, onNext, onBack }) {
  const { assets } = useFinanceContext();
  const [formData] = useState({ ..._data?.finances });

  const isValid = true;
  const handleNext = () => onNext({ finances: formData });

  return (
    <>
      <Stack spacing={4} alignItems="center" justifyContent="center" textAlign="center">
        <SlideIn direction="left">
          <Typography variant="h2" color="text.secondary">
            💰
          </Typography>

          <Typography variant="h1">Other Assets</Typography>
          <SlideIn direction="left">
            <Typography variant="h3" color="text.secondary" fontWeight="light">
              We&apos;ll use this to calculate & forecast your net worth.
            </Typography>
          </SlideIn>
        </SlideIn>

        <List>
          {assets?.allAssets?.map(assetViewModel)?.map((asset) => (
            <React.Fragment key={asset.id}>
              <ListItemButton>
                <ListItemText
                  primary={asset.name || 'New Asset'}
                  secondary={`Value: ${currencyFormatter.format(asset.value ?? asset.amount)}`}
                />
              </ListItemButton>
              <Divider />
            </React.Fragment>
          ))}
        </List>

        {/* <HomesAndAssetsManager data={formData} onChange={handleChange} /> */}
        <ManageAssetsView />
      </Stack>
      <FormFooter {...{ isValid, onNext: handleNext, onBack }} />
    </>
  );
}
